/**
 * @generated SignedSource<<74e3122a890872bc157273c44797169e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceSettingsInput = {
  accessKey?: string | null;
  accessSecret?: string | null;
  adminPath?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  currencyGlobalID?: string | null;
  ecommerceGlobalID: string;
  productsApi?: string | null;
  recaptchaToken: string;
  remoteUrl?: string | null;
  salesChannelID?: string | null;
  siteId?: string | null;
};
export type cCloudIntegrationSalesChannelDialogSaveMutation$variables = {
  input: EcommerceSettingsInput;
};
export type cCloudIntegrationSalesChannelDialogSaveMutation$data = {
  readonly saveEcommerceSettings: {
    readonly ecommerceID: number;
  } | null;
};
export type cCloudIntegrationSalesChannelDialogSaveMutation = {
  response: cCloudIntegrationSalesChannelDialogSaveMutation$data;
  variables: cCloudIntegrationSalesChannelDialogSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "settingsInput",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cCloudIntegrationSalesChannelDialogSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "cCloudIntegrationSalesChannelDialogSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "saveEcommerceSettings",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6531af24f830a5f6092771ea939d7f8c",
    "id": null,
    "metadata": {},
    "name": "cCloudIntegrationSalesChannelDialogSaveMutation",
    "operationKind": "mutation",
    "text": "mutation cCloudIntegrationSalesChannelDialogSaveMutation(\n  $input: EcommerceSettingsInput!\n) {\n  saveEcommerceSettings(settingsInput: $input) {\n    ecommerceID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "16ed99dfd90de350e55fc7c1da85c5da";

export default node;
